module.exports = __webpack_public_path__ + "img/BG.30dddf5d.svg";